"use strict";

exports.__esModule = true;
var _DashboardList = require("./DashboardList");
Object.keys(_DashboardList).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardList[key]) return;
  exports[key] = _DashboardList[key];
});
var _DashboardListAccoridanView = require("./DashboardListAccoridanView");
Object.keys(_DashboardListAccoridanView).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardListAccoridanView[key]) return;
  exports[key] = _DashboardListAccoridanView[key];
});